/** Client-side Översikt match filter — länder/lag only (min 2 chars). */

export const OVERVIEW_SEARCH_MIN_LEN = 2;

export function normalizeOverviewSearchQuery(raw) {
  return String(raw ?? "")
    .trim()
    .toLocaleLowerCase("sv-SE")
    .normalize("NFKC");
}

/**
 * @param {object} m - fixture
 * @param {string} query - normalized lowercase query
 * @param {Record<string, string>} teamsByCode
 */
export function fixtureMatchesOverviewQuery(m, query, teamsByCode) {
  if (query.length < OVERVIEW_SEARCH_MIN_LEN) return true;
  const haystack = [
    m.home_code,
    m.away_code,
    teamsByCode[m.home_code],
    teamsByCode[m.away_code],
  ]
    .filter(Boolean)
    .map((s) => String(s).toLocaleLowerCase("sv-SE").normalize("NFKC"));
  return haystack.some((part) => part.includes(query));
}
